import { useEffect, useState } from "react";
import { usePrefersReducedMotion } from "./use-prefers-reduced-motion";

const DURATION_MS = 1100;
const easeOut = (t: number) => 1 - (1 - t) ** 3;

type CountUpProps = {
  value: number;
  /** How long to wait before counting, so the figure lands after its card does. */
  startDelayMs?: number;
};

/** Counts from zero up to `value`; shows the end value immediately under reduced motion. */
export function CountUp({ value, startDelayMs = 0 }: CountUpProps) {
  const reduceMotion = usePrefersReducedMotion();
  const [display, setDisplay] = useState(reduceMotion ? value : 0);

  useEffect(() => {
    if (reduceMotion) {
      setDisplay(value);
      return;
    }
    let raf = 0;
    let start = 0;
    const step = (now: number) => {
      if (!start) start = now;
      const t = Math.min((now - start) / DURATION_MS, 1);
      setDisplay(Math.round(easeOut(t) * value));
      if (t < 1) raf = requestAnimationFrame(step);
    };
    const timer = setTimeout(() => {
      raf = requestAnimationFrame(step);
    }, startDelayMs);
    return () => {
      clearTimeout(timer);
      cancelAnimationFrame(raf);
    };
  }, [value, startDelayMs, reduceMotion]);

  return <>{display.toLocaleString()}</>;
}
